// src/CombinedChart.js

import React from 'react';
import { Bar, Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, PointElement, Title, Tooltip, Legend, BarElement, LinearScale, LineElement } from 'chart.js';
import { lab } from 'd3';
import GetFormattedDateTime from '../utilities/getFormattedDateTime';


ChartJS.register(
  Title,
  Tooltip,
  Legend,
  PointElement,
  BarElement,
  CategoryScale,
  LinearScale,
  LineElement
);

const RequestResponseTrends = ({chartData}) => {
  // const labels = chartData.map(item => {
  //   const date = new Date(item.Year, item.Month - 1);
  //   return date.toLocaleString('default', { year: '2-digit', month: 'short' });
  // });
  const labels = chartData.map(item => GetFormattedDateTime(item.RespondedOn));
  const responses = chartData.map(item => item.Responses);
  const requests = chartData.map(item => item.Requests);

  const combineDataset = {
    labels: labels,
    datasets: [
      {
       label: 'Response',
       type: 'line',
       data: responses,
       fill: false,
       borderColor: '#387F39',
       backgroundColor: '#387F39',
       tension: 0.1,
       borderWidth: 2,
      yAxisID: 'y-axis-2',
      },
      {
        type: 'bar',
        label: 'Request',
        data: requests,
        backgroundColor: '#FFDA76',
        borderWidth: 0,
        stack: 'false',
      },
      
    ],
  };

  // Chart options
  const options = {
   // aspectRatio: 2.1,
    responsive : true,
    maintainAspectRatio: false, // Allows the canvas to adjust its size
    plugins: {
        title: {
            display: false, // Hides the chart title
          },
          datalabels:{
            display: false,
          },
        
        legend: {       
            display: true, // Show or hide the legend
            position: 'bottom', // Position of the legend
            align: 'center', // Alignment of the legend
            labels: {             
              padding: (0, 15, 0, 10), // Padding around the legend labels
              boxWidth: 7, // Width of the color box in the legend
              boxHeight: 7, // Height of the color box in the legend
              usePointStyle: true, // Use point styles instead of boxes             
            },
            title: {
                display: true,
                padding: -7,
              },
      },
      tooltip: {
        callbacks: {
          label: function(tooltipItem) {
            return tooltipItem.dataset.label + ': ' + tooltipItem.raw;
          },
        },
      },
    },
    layout:{
        padding: {
            bottom: 0, // Remove extra space below the chart
          },        
    },
    scales: {
      x: {
        padding: 0,
        grid:{
            display: false,
        },
        title: {
            display: false,
            text: 'Month'
        },
        ticks: {
            beginAtZero: true,
            padding: 0, 
            display: true, // Hides the y-axis labels
          },
        stacked: true,
        beginAtZero: true,
      },
      y: {
        grid:{
            display: false,
        },
        ticks: {
            suggestedMax:50,
            suggestedMin:1,
            beginAtZero:true,
            max:100,
            autoSkip:true,
            lineHeight:2,
        },
        stacked: true,
        // title: {
        //   display: true,
        //   text: 'Response Count',
        // },
      },
      'y-axis-2': {
        grid:{
            display: false,
        },
          // min: 0, 
          // max: 100,
        type: 'linear',
        position: 'right',
        title: {
          display: true,
          text: 'Responses',
        },
        beginAtZero: true,
        stacked: false,  // Do not stack line chart
      },
     //--- min: 0 ,
    },
  };

  return (
      <Bar data={combineDataset} options={options} />
  );
};

export default RequestResponseTrends;
